import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "@/components/Motion";

const STATS = [
  { n: "16", l: "acomodações privativas" },
  { n: "300 m²", l: "na maior vivenda" },
  { n: "Km 3", l: "Estrada Pico Agudo" },
];

export const Intro = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["-4%", "14%"]);

  return (
    <section id="quinta" ref={ref} data-testid="intro-section" className="relative overflow-hidden bg-[#f4f0e6] py-24 sm:py-36">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>A Quinta</Eyebrow>
            <h2 className="text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#1a382b] sm:text-5xl">
              Um refúgio rústico no alto da serra, onde o tempo corre no ritmo da lareira.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-[#3d4a34] md:text-lg">
              Na Estrada Pico Agudo, em Santo Antônio do Pinhal, cada acomodação foi pensada para a privacidade do casal ou da
              família: madeira de demolição, pedra, ofurôs e banheiras com vista para a Pedra do Baú e para as montanhas de Minas.
            </p>
          </Reveal>
          <div className="mt-14 grid grid-cols-3 gap-4 border-t border-[#d9d2c1] pt-8">
            {STATS.map((s, i) => (
              <Reveal key={s.l} delay={0.1 * i}>
                <p className="text-2xl font-bold tracking-tight text-[#1a382b] sm:text-4xl">{s.n}</p>
                <p className="mt-2 text-xs uppercase tracking-[0.14em] text-[#5f6e62] sm:text-sm">{s.l}</p>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="relative grid grid-cols-5 gap-4 lg:col-span-6">
          <motion.div style={{ y: y1 }} className="col-span-3 overflow-hidden">
            <img src="/fotos/morada-pinhal-10/1.jpg" alt="Sala com lareira na Morada Pinhal" className="aspect-[3/4] w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="col-span-2 mt-20 overflow-hidden">
            <img src="/fotos/vivenda-eucalipto-14/3.jpg" alt="Sala de banho envidraçada da Vivenda Eucalipto" className="aspect-[3/5] w-full object-cover" />
            <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#5f6e62]">Vivenda Eucalipto 14</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
